import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import { TEXT_SMALL } from "../../style";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext } from "react-router-dom";

export default function Selection() {
    const { testCatalogue, testSelection, setTestSelection } = useOutletContext();

    const navigate = useNavigate();

    return (
        <div className="p-2">
            <div className="flex align-items-center justify-content-between">
                <span className={`p-2 border-round ${TEXT_SMALL} text-gray-700 border-1 border-orange-300 bg-orange-100`}>Select Following...</span>
                {testSelection?.course && testSelection?.subject && testSelection?.chapters?.length && (
                    <Button
                        severity="warning"
                        onClick={() => {
                            navigate("../appear");
                        }}
                        label="Start Self Test"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        size="small"
                    />
                )}
            </div>

            <FloatLabel className="mt-6">
                <Dropdown
                    value={testSelection?.course}
                    inputId="courses"
                    options={testCatalogue}
                    optionLabel="title"
                    className="w-full"
                    onChange={(e) => setTestSelection((prev) => ({ ...prev, course: e.value }))}
                    pt={{
                        label: { className: TEXT_SMALL },
                        item: { className: TEXT_SMALL },
                    }}
                />
                <label htmlFor="courses" className={`${TEXT_SMALL}`}>
                    Select Course
                </label>
            </FloatLabel>

            {testSelection?.course && (
                <FloatLabel className="mt-5">
                    <Dropdown
                        value={testSelection?.subject}
                        inputId="courses"
                        options={testSelection?.course?.subjects}
                        optionLabel="title"
                        className="w-full"
                        onChange={(e) => setTestSelection((prev) => ({ ...prev, subject: e.value }))}
                        pt={{
                            label: { className: TEXT_SMALL },
                            item: { className: TEXT_SMALL },
                        }}
                    />
                    <label htmlFor="courses" className={`${TEXT_SMALL}`}>
                        Select Subject
                    </label>
                </FloatLabel>
            )}

            {testSelection?.subject && (
                <FloatLabel className="mt-5">
                    <MultiSelect
                        value={testSelection?.chapters}
                        inputId="chapters"
                        options={testSelection?.subject?.chapters}
                        optionLabel="title"
                        className="w-full"
                        onChange={(e) => setTestSelection((prev) => ({ ...prev, chapters: e.value }))}
                        pt={{
                            label: { className: TEXT_SMALL },
                            item: { className: TEXT_SMALL },
                        }}
                    />
                    <label htmlFor="chapters" className={`${TEXT_SMALL}`}>
                        Select Chapters
                    </label>
                </FloatLabel>
            )}
        </div>
    );
}
